/**
 * Read-only status of the most recent background AI-generation run, so a page
 * can surface a failure instead of polling forever on "processing".
 */

import { authFetch } from './authFetch';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';

export type MappingEntityType = 'patient' | 'practitioner' | 'status' | 'appointment_type';

export interface RunStatus {
    gh_id: string;
    entity_type: string;
    status: 'processing' | 'completed' | 'failed' | null;
    detail: string | null;
    count: number | null;
    total: number | null;
    started_at: string | null;
    finished_at: string | null;
}

export const runStatusApi = {
    async get(ghId: string, entityType: MappingEntityType): Promise<RunStatus> {
        const res = await authFetch(`${API_BASE_URL}/run-status/${ghId}?entity_type=${entityType}`);
        if (!res.ok) throw new Error('Failed to fetch run status');
        return res.json();
    },
};
